export const DISPERSEABI = {
    auroraTestnet: "0x30d25c739BF4859DC8C12c67E89954824bfb39FE",
};